/**
 * Low-level tier helpers with no dependencies of their own.
 *
 * They live apart from `resolveStep` and `standalone` so those two can both use
 * them without importing each other: routing needs to know what a standalone is,
 * and the standalone rules need to match histories to tiers.
 */

/** Resolve a possibly-populated tierSetting (string id, or populated { _id }) to its id. */
export const tierIdOf = (h) => h?.tierSetting?._id || h?.tierSetting;

/**
 * A standalone verification — the tier-level-0 check a case asks a client for,
 * outside the 1..N ladder. Several can be open at once.
 */
export const isStandaloneTier = (tier) => tier?.type === "standalone";
